export class BrowserHelper {
  private static _cache: Map<string, string> | null = null;

  static parseUserAgent(): Map<string, string> {
    if (BrowserHelper._cache) {
      return BrowserHelper._cache;
    }

    const nAgt = navigator.userAgent;

    let browserName = navigator.appName;
    let fullVersion = navigator.appVersion;
    let os = navigator.platform;

    const nameOffset = nAgt.lastIndexOf(' ') + 1;
    const verOffset = nAgt.lastIndexOf('/');

    const osType = nAgt.indexOf('WOW64') !== -1 ? '(64 bit)' : '';
    os += osType;

    if (new RegExp('android').test(nAgt)) os = 'android';
    if (new RegExp('iPhone|iPad|iPod').test(nAgt)) os = 'ios';
    if (new RegExp('IEMobile').test(nAgt) || new RegExp('WPDesktop').test(nAgt)) os = 'wp';

    if (verOffset !== -1) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);

      if (browserName.toLowerCase() === browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    const ix = fullVersion.indexOf(';');
    if (ix !== -1) {
      fullVersion = fullVersion.substring(0, ix);
    }

    const majorVersion = parseInt(fullVersion, 10) || 0;

    if (majorVersion === 0) {
      fullVersion = navigator.appVersion;
    }

    BrowserHelper._cache = new Map<string, string>([
      ['os', os],
      ['browser', browserName + ' ' + fullVersion],
    ]);

    return BrowserHelper._cache;
  }
}
